import * as React from 'react';
import TextArea from 'antd/lib/input/TextArea';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';

interface Props extends BaseFormItemProps {
  maxLength?: number;
}

class TextAreaFormItem extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {disabled, maxLength} = this.props;
    return (
      <BaseFormItem
        {...this.props}
        input={<TextArea
          className="mild-disabled"
          autoSize={{minRows: 2, maxRows: 6}}
          disabled={disabled}
          maxLength={maxLength}
        />}
      />
    );
  }
}

export default TextAreaFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/TextAreaFormItem.tsx